import ProblemHubDiagram from "@/components/landing/ProblemHubDiagram";

const problems = [
  { number: "01", title: "I'll start Monday." },
  { number: "02", title: "Tomorrow for sure." },
  { number: "03", title: "Fresh start next month." },
  { number: "04", title: "This time is different." },
];

export default function ProblemSection() {
  return (
    <section id="problem" className="nm-section-light reveal-section" data-reveal data-testid="problem-section">
      <div className="nm-container pt-8 pb-24 md:pt-12 md:pb-20">
        <span className="nm-eyebrow inline-block text-[#222] mb-16 md:mb-12">
          The Problem
        </span>
        <div className="w-full">
          <ProblemHubDiagram />
        </div>
      </div>

    </section>
  );
}